import React, { PropsWithChildren } from 'react';
import { Helmet } from 'react-helmet';
import { usePromiseTracker } from 'react-promise-tracker';
import { Loader } from 'is24-corecss';
import Footer from '../footer/Footer';
import Header from '../header/Header';
import styles from './PageWrapper.module.css';
import WhiteHeader from '../header/WhiteHeader';

interface Props {
  children?: React.ReactNode;
  title?: string;
  isWhiteHeader?: boolean;
}

const PageWrapper: React.FC<Props> = ({ children, title, isWhiteHeader }: PropsWithChildren<Props>) => {
  const { promiseInProgress } = usePromiseTracker();

  return (
    <>
      <Helmet title={`${title} - ImmoScout24`} />
      {promiseInProgress && (
        <div className={styles.overlay}>
          <Loader />
        </div>
      )}
      <div>
        {!isWhiteHeader && <div className='grid-item one-whole grid-align-start'>{<Header />}</div>}
        {isWhiteHeader && <div className='grid-item one-whole grid-align-start'>{<WhiteHeader />}</div>}
        <div className='content-wrapper' data-nsm-page-content>
          <div className={`grid grid-flex ${styles.pageWrapper}`}>
            <div className={`grid-item one-whole ${styles.contentWrapper}`}>{children}</div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default PageWrapper;
